// @flow

import type {Column, StopResizeParams} from '../typedef';

export const changeColumnWidth = <DataColumn>(
    columns: Array<Column<DataColumn>>,
    ownColumn: StopResizeParams<DataColumn>
): Array<Column<DataColumn>> => {
    return columns.map(column => {
        if (column.columnId === ownColumn.columnId) {
            return {
                ...column,
                width: ownColumn.width
            };
        }
        return column;
    });
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
